import React from 'react';
import { gql } from '@apollo/client';
import TimestampFields from 'components/TimestampFields';
import { Show, SimpleShowLayout, TextField, BooleanField, NumberField } from 'react-admin';
import DateTimeField from 'components/DateTimeField';

const CheckOutsShow = () => (
  <Show data-testid="check-outs-show">
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <TextField label="Job ID" source="job.id" />
      <TextField label="Professional ID" source="professional.id" />
      <TextField label="Location ID" source="location.id" />
      <NumberField options={{ maximumFractionDigits: 10 }} source="latitude" />
      <NumberField options={{ maximumFractionDigits: 10 }} source="longitude" />
      <TextField source="distance" label="Distance (ft)" />
      <BooleanField source="manual_override" />
      <BooleanField source="accepted" />
      <DateTimeField source="created_at" label="Check Out Time" />
      <DateTimeField source="time" label="Professional Submitted Time" />
      <TimestampFields />
    </SimpleShowLayout>
  </Show>
);

CheckOutsShow.query = gql`
  query GET_ONE($id: Int!) {
    checkOut(id: $id) {
      id
      job {
        id
      }
      location {
        id
      }
      professional {
        id
      }
      latitude
      longitude
      accepted
      time
      distance
      created_at
      updated_at
      manual_override
    }
  }
`;

export default CheckOutsShow;
